import React, { useState, useEffect } from "react";
import { IoCalendarOutline } from "react-icons/io5";

interface MonthFilterProps {
  onDateRangeChange: (range: { start: string, end: string }) => void;
}

const MonthFilter: React.FC<MonthFilterProps> = ({ onDateRangeChange }) => {
  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth());

  const months = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];

  const handleMonthChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const monthIndex = parseInt(event.target.value);
    setSelectedMonth(monthIndex);
  };

  const getMonthDateRange = (monthIndex: number) => {
    const year = new Date().getFullYear();
    const startDate = new Date(Date.UTC(year, monthIndex, 1));
    const endDate = new Date(Date.UTC(year, monthIndex + 1, 0));
    return {
      start: startDate.toISOString().split('T')[0],
      end: endDate.toISOString().split('T')[0]
    };
  };

  useEffect(() => {
    const range = getMonthDateRange(selectedMonth);
    onDateRangeChange(range);
  }, [selectedMonth, onDateRangeChange]);

  return (
    <div className="relative inline-block font-semi-bold focus:outline-none">
      <select
        value={selectedMonth}
        onChange={handleMonthChange}
        className="py-2 px-6 pr-8 text-primary/300 bg-white rounded-md appearance-none focus:outline-none"
      >
        {months.map((month, index) => (
          <option key={index} value={index}>
            {months[index]}
          </option>
        ))}
      </select>
      <IoCalendarOutline className="absolute right-2 top-1/2 transform -translate-y-1/2 text-primary/300" />
    </div>
  );
}

export default MonthFilter;